import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/NewRequest';

export interface IPhones {
  phoneType: number;
  phoneTypeDesc: string;
  prefixId: number;
  prefix: number;
  phoneNum: string;
  email: string;
}

export interface IFamilyMembers {
  relation: number;
  relationDesc: string;
  idNumber: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
  gender: number;
}

export interface IAddresses {
  addressTypeId: number;
  addressTypeDesc: string;
  street: string;
  numHouse: string;
  numApartment: string;
  entrance: string;
  neighborhood: string;
  townId: number;
  zipCode: string;
  postOffice: string;
  countryId: number;
  abroadTown: string;
}

export interface IDisabilitySections {
  caseNumber: string;
  lastCommitteeDate: Date;
  sectionCode: string;
  sectionDescription: string;
  disabilityStartDate: Date;
  currentDisabilityStartDate: Date;
  disabilityPercent: string;
  sectionValidTo: string;
  considerPercent: string;
  nonConsiderPercent: string;
}

export interface IPersonalDetails {
  mainPhonePrefix?: number;
  mainPhone?: string;
  caseNumber: string;
  israeliId: string;
  firstName: string;
  lastName: string;
  familyStatus: string;
  maritalStatusId: number;
  accountNum: string;
  phones: IPhones[];
  familyMembers: IFamilyMembers[];
  addresses: IAddresses[];
  disabilityPercent: string;
  disabilitySections: IDisabilitySections[];
  disabilityStatus: string | undefined;
  bankDetails: {
    accountNum: string;
    bankCode: string;
    bankName: string;
    branchCode: string;
    branchName: string;
  };
  representatives: IRepresentative[];
  msgDeliveryOptionId: number;
}

export interface IRepresentative {
  name: string;
  idNumber: string;
  license: string;
  mobilePrefix: string;
  mobilePhoneNumber: string;
  email: string;
  representationRequestStatus: number | null;
  updDate: Date;
  msgDeliveryOptionId: number;
}

export const getPersonalDetails = async (isrId?: string) => {
  const personalDetails = await api.get<IPersonalDetails>(
    isrId
      ? `${baseURL}/PersonalDetails?isrId=${isrId}`
      : addImposterToUrl(`${baseURL}/PersonalDetails`, true)
  );
  const sensitizedPersonalDetails = personalDetails.data;

  if (!sensitizedPersonalDetails) return;

  if (sensitizedPersonalDetails.mainPhone) {
    sensitizedPersonalDetails.mainPhone =
      personalDetails.data.mainPhone?.trim();
    if (sensitizedPersonalDetails.mainPhone?.length !== 7)
      sensitizedPersonalDetails.mainPhone = '';
  }

  if (sensitizedPersonalDetails.phones?.length > 0)
    sensitizedPersonalDetails.phones = personalDetails.data.phones.map(
      (phone) => ({
        ...phone,
        phoneNum:
          phone.phoneNum.trim().length !== 7 ? '' : phone?.phoneNum.trim(),
      })
    );

  if (sensitizedPersonalDetails) return sensitizedPersonalDetails;
};

export const updateRepresentativeStatus = async (
  representativeIsrId: string,
  statusCode: number
) => {
  const response = await api.post(
    addImposterToUrl(
      `/Representative/status?representativeIsrId=${representativeIsrId}&statuscode=${statusCode}`,
      false
    )
  );
  return response.data;
};

export const postMessageDeliveryType = async (msgDeliveryType: number) => {
  await api.put(
    addImposterToUrl(
      `${baseURL}/PersonalDetails/UpdateMessageDeliveryOption?msgDeliveryOptionId=${msgDeliveryType}`,
      false
    )
  );
};
